/* ── IncomeBazaar redesign: Deposit / Withdraw form pages ──
   Shared by Deposit.jsx and Withdraw.jsx. Centered white panel on the
   blush page background, inside the app's 1240px .content wrapper. */

.deposit {
  width: 100%;
  max-width: 800px;
  margin: 2rem auto 3rem;
  padding: 1.9rem 2rem 2rem;
  background: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(27, 37, 52, 0.05), 0 6px 18px rgba(120, 30, 30, 0.05);
  display: flex;
  flex-direction: column;
}

/* ── header ── */
.header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.title {
  font-family: var(--font-serif) !important;
  letter-spacing: -0.01em;
}

.subLine {
  margin-top: 0.35rem;
  display: block;
}

/* ── dividers ── */
.divider {
  height: 1px;
  background: var(--ib-line);
  border: 0;
  margin: 1.1rem 0;
}

/* ── content column ── */
.depositDetails {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

/* ── available balance strip ── */
.availableBalance {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1.1rem;
  background: var(--ib-line-2);
  border: 1px solid var(--ib-line);
  border-radius: 12px;
}

.balanceLabel {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--ib-muted);
}

.balanceValue {
  font-variant-numeric: tabular-nums lining-nums;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--ib-ink);
}

/* ── amount input + action ── */
.fieldLabel {
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ib-muted);
  margin-bottom: -0.2rem;
}

.amountRow {
  max-width: 26rem;
}

/* ── notes ── */
.noteMuted {
  display: block;
  font-size: 0.8rem;
  color: var(--ib-muted);
  line-height: 1.5;
}

/* ── IMPS warning ── */
.warn {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.7rem 0.9rem;
  background: var(--ib-red-soft);
  border: 1px solid var(--ib-salmon-tint);
  border-radius: 10px;
  color: var(--ib-red);
  font-size: 0.9rem;
  font-weight: 700;
}

/* ── NEFT/RTGS instructions ── */
.instr {
  display: block;
  font-size: 0.9rem;
  color: var(--ib-ink);
  line-height: 1.55;
}

/* ── escrow / bank details sub-card ── */
.escrowCard {
  border: 1px solid var(--ib-line);
  border-radius: 12px;
  padding: 1.1rem 1.2rem;
  background: var(--ib-panel);
}

.escrowTitle {
  display: block;
  font-family: var(--font-serif);
  font-size: 1rem;
  font-weight: 700;
  color: var(--ib-ink);
  margin-bottom: 0.9rem;
}

.attrGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem 1.4rem;
}

.attr {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.attrLabel {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.045em;
  text-transform: uppercase;
  color: var(--ib-muted);
}

.attrValue {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ib-ink);
  font-variant-numeric: tabular-nums lining-nums;
  word-break: break-word;
}

/* ── footer support note ── */
.footerNote {
  display: block;
  font-size: 0.8rem;
  color: var(--ib-muted);
  line-height: 1.5;
}

/* ── change bank account (withdraw) ── */
.changeBankAccount {
  margin-top: 0.9rem;
  width: 100%;
  max-width: 26rem;
}

@media only screen and (max-width: 640px) {
  .deposit {
    margin: 1rem auto 2rem;
    padding: 1.4rem 1.2rem 1.6rem;
    border-radius: 12px;
  }

  .attrGrid {
    grid-template-columns: 1fr;
  }

  .availableBalance {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
  }
}
